export const HideUnhideControl = (value) => { 
    
    if(value === undefined || value === ""){
        return false
    } else{
        return true
    }    
}